export const SLIDE_TIMER = 5000;
